export default __webpack_public_path__ + "static/media/(7).43a0d763.jpg";